import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/60">
      <div className="max-w-4xl mx-auto">
        <div className="reveal text-center">
          <span className="text-primary-600 font-label text-sm tracking-wide">影迷讨论</span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            老话题，新问题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            关于两代《蜜桃成熟时》，被问得最多的几个问题都在这里。点开想看的那一条即可。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((item, index) => {
            const isOpen = open === index;
            return (
              <div
                key={item.q}
                className="reveal bg-background-50 border border-background-200/80 rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-5 text-foreground-600 text-xs md:text-sm leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}